import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNepal = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_29_1028)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M23.9297 13.3045L23.9293 13.304L23.9292 13.3045H23.9297Z",
				fill: "#0052B4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M23.9292 13.3043C23.9292 13.3043 23.9293 13.3042 23.9293 13.304L10.7693 0.0623932C10.1757 0.122909 9.59475 0.22669 9.02986 0.370549C3.83897 1.69219 0 12 0 12C0 12 16.7999 23.2423 18.7165 21.9452C19.1 21.6857 19.4677 21.4046 19.8177 21.1036L12.0185 13.3043H23.9292Z",
				fill: "#0052B4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M20.8695 12L9.19898 0.329483C3.92287 1.59122 0 6.33712 0 12C0 18.6274 5.37262 24 12 24C14.5139 24 16.8467 23.2265 18.7748 21.9052L8.86955 12H20.8695Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.4127 17.7184L9.94719 17.0291L10.7276 15.6098L9.1362 15.9142L8.93455 14.3065L7.8261 15.4889L6.71764 14.3065L6.51594 15.9142L4.92458 15.6097L5.705 17.0291L4.23941 17.7184L5.705 18.4077L4.92458 19.8271L6.51603 19.5227L6.7176 21.1303L7.8261 19.9479L8.93455 21.1303L9.1362 19.5227L10.7276 19.8271L9.94714 18.4078L11.4127 17.7184Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.4348 6.65545L9.36886 6.15412L9.93647 5.1218L8.77899 5.34323L8.63231 4.17389L7.82611 5.0339L7.01991 4.17389L6.87319 5.34323L5.7157 5.1218L6.28336 6.15412L5.21738 6.65545L7.82611 7.17726L10.4348 6.65545Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.9565 6.65546C10.9565 8.38435 9.55493 9.78591 7.82604 9.78591C6.09715 9.78591 4.69559 8.38435 4.69559 6.65546",
				fill: "#F0F0F0"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_29_1028",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgNepal;
